
const contactInfo = {
    address: "1040 Gulf Breeze Parkway",
    suite: "Suite 100",
    city: "Gulf Breeze, FL 32561",
    email: "AIASCScheduler@andrewsinstitutesc.com"
};


const Andrews = ({
    SurgeryFormData,
    setSurgeryFormData,
    currentPage,
    pageRefs,
    pageTitles,
    isNext,
    invalidFields,
    handleInputChange,
    handleCheckboxChange,
    verifyDob,
    setVerifyDob,
    signatures,
    setSignatures,
    isEditing,
    toggleEditMode,
    updateSignatureData,
    clearSignature,
    canvasRefs,
    surgeonOptionsMap,
    surgeonFullnameOptionsMap,
    docSignature,
    logo,
    renderNextButton,
    renderSurgeryUploadButton,
    surgeryUpload,
    formatDate,
    handleMedicationTimeChange,
    getCentralAmericaDate,
    getCentralAmericaTime,
    handleNext,
    Head,
    SignatureField,
    Paragraph,
    FormInput,
    Logo,
    DOBPickerInput,
    SelectInput,
    TimePickerInput,
    TextInput,
    SurgeryInfoDisplay,
    DatePickerInput,
    RadioGroup,
    anesthesiaOptions,
    eyesOptions,
    TextAreaInput,
    MedTimePicker,
    andrews,
    handleNestedInputChange,
    displayDate,
    TextArea,
}) => {
    return (
        <>
            <form className="bg-white">
                {/* Page 1 */}
                {currentPage === 0 && (
                    <div ref={pageRefs.current[currentPage]}
                        className="max-w-5xl w-full bg-white text-base font-medium text-black">
                        <div className="px-1 mx-8 py-2">

                            <Logo src={andrews} className="w-20 h-30" contactInfo={contactInfo} showContact={true} />
                            <Head title={pageTitles['Andrews Institute'][currentPage]} />

                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                                <FormInput
                                    key="Patient Name"
                                    id="Patient Name"
                                    label="Patient Name"
                                    type="text"
                                    disabled={true}
                                    value={`${SurgeryFormData["first_name"]} ${SurgeryFormData["last_name"]}`}
                                    onChange={handleInputChange}
                                    required={false}
                                />

                                <SelectInput
                                    id="surgeon"
                                    label="Surgeon"
                                    options={surgeonOptionsMap[localStorage.getItem("digital-form-dept-practice")] || []}
                                    value={SurgeryFormData.surgeon}
                                    onChange={(e) => {
                                        const selectedSignature = docSignature[e.target.value];

                                        setSignatures((prev) => ({
                                            ...prev,
                                            doctor_signature: selectedSignature,
                                        }));

                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            surgeon_fullname: surgeonFullnameOptionsMap[e.target.value],
                                        }));


                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            doctor_signature: selectedSignature,
                                        }));
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            surgeon: e.target.value,
                                        }));
                                    }}

                                    disabled={isNext}
                                    invalid={invalidFields.includes("Surgeon") && !SurgeryFormData.surgeon}
                                    errorMessage="Please select a surgeon."
                                />

                            </div>


                            {/* Commented out: SSN and Gender fields
                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <FormInput
                                    key='ssn'
                                    id='ssn'
                                    label='SSN'
                                    type="text"
                                    disabled={isNext}
                                    value={SurgeryFormData['ssn']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('ssn') && !SurgeryFormData['ssn']}
                                    required={false}
                                />

                                <RadioGroup
                                    label="Gender"
                                    name="gender"
                                    required
                                    disabled={isNext}
                                    selectedValue={SurgeryFormData.gender}
                                    onChange={(value) => {
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            gender: value,
                                        }));
                                    }}
                                    options={[
                                        { value: "M", label: "Male" },
                                        { value: "F", label: "Female" },
                                    ]}
                                />
                            </div>
                            */}

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <DOBPickerInput
                                    id="dob"
                                    label="Date of Birth"
                                    value={verifyDob}
                                    onChange={(date) => {
                                        setVerifyDob(date || null);
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            dob: date ? formatDate(date) : "",
                                        }));
                                    }}
                                    disabled={isNext}
                                    required
                                    invalid={invalidFields.includes("dob") && !verifyDob}
                                />

                                <DatePickerInput
                                    id="requested_date_of_surgery"
                                    label="Date"
                                    value={SurgeryFormData.requested_date_of_surgery}
                                    onChange={(date) =>
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            requested_date_of_surgery: date ? formatDate(date) : "",
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={
                                        invalidFields.includes("requested_date_of_surgery") &&
                                        !SurgeryFormData.requested_date_of_surgery
                                    }
                                    minDate={new Date()}
                                />
                            </div>


                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* Requested Date of surgery */}

                                <TimePickerInput
                                    id="requested_time_of_surgery"
                                    label="Start Time"
                                    value={SurgeryFormData.requested_time_of_surgery}
                                    onChange={(date) =>
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            requested_time_of_surgery: date,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={
                                        invalidFields.includes("requested_time_of_surgery") &&
                                        !SurgeryFormData.requested_time_of_surgery
                                    }
                                />
                                {[
                                    {
                                        id: "length_of_surgery",
                                        label: "Length",
                                        required: true,
                                    }
                                    // {
                                    //     id: "office_phone",
                                    //     label: "Office Phone",
                                    //     required: false,
                                    // }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>


                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[
                                    {
                                        id: "icd10_codes",
                                        label: "ICD 10 Code(s)",
                                        required: false,
                                    },
                                    {
                                        id: "cpt_codes",
                                        label: "CPT Codes",
                                        required: false,
                                    }

                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            {/* 
                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <DOBPickerInput
                                    id="dob"
                                    label="Date of Birth"
                                    value={verifyDob}
                                    onChange={(date) => {
                                        setVerifyDob(date || null);
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            dob: date ? formatDate(date) : "",
                                        }));
                                    }}
                                    disabled={isNext}
                                    required
                                    invalid={invalidFields.includes("dob") && !verifyDob}
                                />

                                <FormInput
                                    key='cellphone'
                                    id='cellphone'
                                    label='Cell Phone'
                                    type="text"
                                    disabled={isNext}
                                    value={SurgeryFormData['cellphone']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('Cell Phone') && !SurgeryFormData['cellphone']}
                                    required={false}
                                />
                            </div>  */}


                            {/* 
                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[

                                    {
                                        id: "office_contact",
                                        label: "Office Contact",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !SurgeryFormData[id]}
                                        required={required}
                                    />
                                ))}


                            </div> */}
                            {/* 
                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[
                                    {
                                        id: "length_of_surgery",
                                        label: "Length Of Surgery",
                                        required: true,
                                    },
                                    {
                                        id: "office_phone",
                                        label: "Office Phone",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div> */}

                            <label className="font-bold text-black"> PROCEDURE DESCRIPTION:</label>


                            <RadioGroup
                                label=""
                                name="eyes"
                                options={eyesOptions}
                                selectedValue={SurgeryFormData.eyes}
                                onChange={(value) => {
                                    setSurgeryFormData((prev) => ({
                                        ...prev,
                                        eyes: value,
                                    }));
                                }}
                                disabled={isNext}
                            />

                            <TextInput
                                id="procedure_description"
                                label=""
                                value={SurgeryFormData.procedure_description}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("procedure_description") && !SurgeryFormData.procedure_description}
                            />


                            {/* <TextInput
                                id="diagnosis"
                                label="Diagnosis"
                                required
                                value={SurgeryFormData.diagnosis}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("diagnosis") && !SurgeryFormData.diagnosis}
                            /> */}

                            <label className="font-bold text-black"> EQUIPMENT:</label>


                            <div className="my-4 grid grid-cols-1 sm:grid-cols-3 gap-2">

                                <div className="flex gap-2">

                                    <label htmlFor="nkda" className="text-sm font-medium text-black">SPECIAL EQUIPMENT (LIST):</label>
                                    <input
                                        type="checkbox"
                                        id="special_equipment"
                                        checked={SurgeryFormData.special_equipment}
                                        onChange={(e) => {
                                            setSurgeryFormData((prev) => ({
                                                ...prev,
                                                special_equipment: e.target.checked,
                                            }));
                                        }}
                                        disabled={isNext}
                                    />
                                </div>

                                {/* vendor_rep Rep Radio Buttons */}
                                <RadioGroup
                                    label="Vendor Rep"
                                    name="vendor_rep"
                                    required={false} // set true if it's required
                                    disabled={isNext}
                                    selectedValue={SurgeryFormData.vendor_rep}
                                    onChange={(value) => {
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            vendor_rep: value,
                                        }));
                                    }}
                                    options={[
                                        { value: true, label: "Yes" },
                                        { value: false, label: "No" },
                                    ]}
                                />

                                {/* C-Arm Radio Buttons */}
                                <RadioGroup
                                    label="C-Arm Required"
                                    name="c_arm_required"
                                    required={false} // Set to true if needed
                                    disabled={isNext}
                                    selectedValue={SurgeryFormData.c_arm_required}
                                    onChange={(value) => {
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            c_arm_required: value,
                                        }));
                                    }}
                                    options={[
                                        { value: "yes", label: "Yes" },
                                        { value: "no", label: "No" },
                                    ]}
                                />



                            </div>
                            {/* Special Equipment */}
                            <TextInput
                                id="special_equipment"
                                label="Special Equipment"
                                value={SurgeryFormData.special_equipment}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("special_equipment") && !SurgeryFormData.special_equipment}
                            />

                            {/* Row 10: Type */}
                            {/* <TextInput
                                id="type"
                                label="Type"
                                value={SurgeryFormData.type}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("type") && !SurgeryFormData.type}
                            /> */}

                        </div>
                    </div>
                )}

                {/* Page 2 */}
                {currentPage === 1 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white text-base font-medium text-black">
                        <div className="px-1 mx-8  py-2">
                            {/* <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="flex items-center">
                                    <label htmlFor="faxInstructions" className="block text-base font-medium text-black">Please Fax Pre Admission Testing Results to (850) 961-8539</label>
                                </div>
                            </div> */}






                            <label className="font-bold text-black"> ANESTHESIA:</label>


                            <RadioGroup
                                label=""
                                name="anesthesia"
                                options={[
                                    { value: "mac", label: "MAC" },
                                    { value: "regional", label: "Regional" },
                                    { value: "general", label: "General" },
                                    { value: "local", label: "Local (no sedation - Anesthesiologist monitoring)" },
                                ]}
                                selectedValue={SurgeryFormData.anesthesia}
                                onChange={(value) => {
                                    setSurgeryFormData((prev) => ({
                                        ...prev,
                                        anesthesia: value,
                                    }));
                                }}
                                disabled={isNext}
                            />
                            <TextInput
                                id="block_anesthesiologist"
                                label="BLOCK TYPE"
                                value={SurgeryFormData.block_anesthesiologist}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("block_anesthesiologist") && !SurgeryFormData.block_anesthesiologist}
                            />


                            {/* CATHETER Buttons */}
                            <RadioGroup
                                label="PAIN PUMP/LONG TERM CATHETER:"
                                name="catheter"
                                required={false} // Set to true if needed
                                disabled={isNext}
                                selectedValue={SurgeryFormData.catheter}
                                onChange={(value) => {
                                    setSurgeryFormData((prev) => ({
                                        ...prev,
                                        catheter: value,
                                    }));
                                }}
                                options={[
                                    { value: "yes", label: "Yes" },
                                    { value: "no", label: "No" },
                                ]}
                            />

                            {/* Special Needs */}
                            {/* <TextInput
                                id="special_needs"
                                label="Special Needs"
                                value={SurgeryFormData.special_needs}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("special_needs") && !SurgeryFormData.special_needs}
                            /> */}

                            <TextInput
                                id="pat_notes"
                                label="P.A.T. Notes"
                                value={SurgeryFormData.pat_notes}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("pat_notes") && !SurgeryFormData.pat_notes}
                            />

                            {/* Allergies */}

                            <TextInput
                                id="allergies"
                                label="ALLERGIES (must match H&P):"
                                value={SurgeryFormData.allergies}
                                onChange={handleInputChange}
                                disabled={isNext || SurgeryFormData.nkda}
                                invalid={invalidFields.includes("allergies") && !SurgeryFormData.allergies}
                            />

                            <div className="flex items-center gap-2 mt-2">
                                <input
                                    type="checkbox"
                                    id="nkda"
                                    checked={SurgeryFormData.nkda || SurgeryFormData.allergies === "NKDA"}
                                    onChange={(e) => {
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            nkda: e.target.checked,
                                            allergies: e.target.checked ? "NKDA" : "",
                                        }));
                                    }}
                                    disabled={isNext}
                                />
                                <label htmlFor="nkda" className="text-sm font-medium text-black">NKDA</label>
                            </div>


                            {/* Authorization Contact Number */}
                            <label className="font-bold text-black mt-2"> VERIFICATION:</label>

                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                                <RadioGroup
                                    label="WC Case?"
                                    name="wc_case"
                                    selectedValue={SurgeryFormData.wc_case}
                                    onChange={(value) => {
                                        setSurgeryFormData((prev) => {
                                            const updated = { ...prev, wc_case: value };
                                            return updated;
                                        });
                                    }}
                                    disabled={isNext}
                                    options={[
                                        { value: true, label: "Yes" },
                                        { value: false, label: "No" },
                                    ]}
                                />



                                <RadioGroup
                                    label="Authorization Required"
                                    name="authorization_required"
                                    selectedValue={SurgeryFormData.authorization_required}
                                    onChange={(value) =>
                                        setSurgeryFormData({
                                            ...SurgeryFormData,
                                            authorization_required: value,
                                        })
                                    }
                                    disabled={isNext}
                                    options={[
                                        { value: true, label: "Yes" },
                                        { value: false, label: "No" },
                                    ]}
                                />
                            </div>
                            <TextInput
                                id="authorization_number"
                                label="CONFIRMATION/AUTHORIZATION NUMBER:"
                                value={SurgeryFormData.authorization_number}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("authorization_number") && !SurgeryFormData.authorization_number}
                            />

                            {/* Authorization Contact 
                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {[
                                    {
                                        id: "contact_person",
                                        label: "Contact Person",
                                        required: false,
                                    },
                                    {
                                        id: "contact_phone",
                                        label: "Contact Phone",
                                        required: false,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div> */}



                            {/* Authorization Contact */}

                            {/* <TextInput
                                id="contact_provider_organization"
                                label="Contact/ Provider/ Organization"
                                value={SurgeryFormData.contact_provider_organization}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("contact_provider_organization") && !SurgeryFormData.contact_provider_organization}
                            /> */}

                            <div className="mt-6 p-4">
                                <p className="font-semibold text-black mb-2">SURGERY REQUEST MUST INCLUDE:</p>
                                <ul className="list-none space-y-1 text-sm font-semibold text-black">
                                    <li>- VALID FORM OF ID (DRIVER'S LICENSE, MILITARY ID, PASSPORT, ETC.)</li>
                                    <li>- INSURANCE ID CARD (IF APPLICABLE)</li>
                                    <li>- HISTORY & PHYSICAL (dated within last 30 days)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                )}

                {/* Page 3 */}
                {currentPage === 2 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white text-base font-medium text-black">

                        <div className="px-1 mx-8 py-2 bg-white">

                            <Logo src={andrews} className="w-20 h-30" contactInfo={contactInfo} showContact={true} />
                            <Head title={pageTitles['Andrews Institute'][currentPage]} />

                            <h4 className="text-xl font-semibold text-blue-600 flex-grow text-center font-['Roboto']" id="header">
                                (To be completed by a practioner performing the procedure)
                            </h4>
                            <div className="flex items-center gap-2">

                                <Paragraph>
                                    I
                                </Paragraph>

                                <Paragraph>
                                    {SurgeryFormData.surgeon_fullname ? SurgeryFormData.surgeon_fullname : SurgeryFormData.surgeon}
                                </Paragraph>

                                <Paragraph>
                                    Practitioner, will be performing the following procedure

                                </Paragraph>

                            </div>

                            <TextArea
                                id="procedure_description"
                                value={SurgeryFormData.procedure_description}
                                onChange={handleInputChange}
                                disabled={false}
                            />
                            <Paragraph>
                                On {SurgeryFormData.first_name} {SurgeryFormData.last_name} ("Patient").
                            </Paragraph>
                            <Paragraph>
                                I hereby certify that I have informed the Patient (and/or their health care surrogate or proxy, if applicable) of the
                                procedure I will be performing, and of the risks, benefits and alternatives to this procedure. The Patient (and/or their
                                health care surrogate or proxy, if applicable) has had the opportunity to ask me questions about the risks, benefits and
                                alternatives to this procedure and has provided me his/her informed consent to perform this procedure at Andrews
                                Institute ASC, LLC (the “Surgery Center”).
                            </Paragraph>


                            <div className="mb-4">
                                <label className="block text-base text-black mb-3 font-bold">Signature of Practitioner :</label>

                                {SurgeryFormData['doctor_signature'] ? ( // Toggle between edit and display mode
                                    <img
                                        src={SurgeryFormData['doctor_signature']}
                                        alt="Signature"
                                        loading="eager"
                                        style={{
                                            width: '300px',
                                            height: '100px',
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                            objectFit: 'contain',
                                            display: 'block',
                                        }}
                                    />
                                ) : (
                                    null
                                )}
                            </div>


                            <div className="mb-4 flex flex-col sm:flex-row flex-wrap gap-4 items-center">

                                <p className="font-roboto text-base text-black whitespace-nowrap mx-1">
                                    {SurgeryFormData.signedDate}
                                </p>
                                <p className="font-roboto text-base text-black whitespace-nowrap">
                                    {SurgeryFormData.signedTime}
                                </p>
                                {!isNext && (
                                    <button
                                        type="button"
                                        onClick={() =>
                                            setSurgeryFormData({
                                                ...SurgeryFormData,
                                                signedDate: getCentralAmericaDate(),
                                                signedTime: getCentralAmericaTime(),
                                            })
                                        }
                                        disabled={isNext}
                                        className="p-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white focus:outline-none"
                                        title="Set Central America Date & Time"
                                    >
                                        <i className="fas fa-calendar-days text-white text-lg"></i>
                                    </button>
                                )}
                            </div>




                            <div className="text-base text-black leading-relaxed my-4">
                                <Paragraph>
                                    1. I have authorized and requested that my Practitioner, his/her assistants, or his/her designees, perform such
                                    procedure as are necessary and desirable in the exercise of his/her professional judgment. I am aware that
                                    my Practitioner may have an ownership in the Surgery Center and understand that I may have my
                                    procedure performed at any other facility where my Practitioner has privileges. I understand that my
                                    Practitioner and Other Physicians (defined below) are not employees of the Surgery Center.
                                </Paragraph>

                                <Paragraph>
                                    2. The above Practitioner has explained to me that during the course of the procedure(s):
                                </Paragraph>
                                <Paragraph>
                                    <ul className="list-[lower-alpha] pl-5 space-y-2">
                                        <li>Unforeseen conditions may be revealed.</li>
                                        <li>Damage may result from the recognized specific risks explained to me for the planned procedure(s).</li>
                                        <li>It may require surgical repair or necessitate an extension of the original procedure(s).</li>
                                        <li>Different procedure(s) than those set forth above may be required.</li>
                                    </ul>
                                </Paragraph>
                                <Paragraph>
                                    3. I have been informed that there are other risks, such as severe blood loss, reaction to blood or blood products,
                                    infection, loss or damage to teeth, or cardiac arrest that are risks associated with the performance of any
                                    procedure.
                                </Paragraph>



                                <Paragraph>
                                    4. I consent to pre- and post-surgery medication and anesthesia (local, regional, IV conscious sedation, or
                                    general) for surgery as may be deemed necessary by my Practitioner or by the anesthesiologists at the Surgery
                                    Center. I understand there are inherent risks to receiving medications and anesthesia, and there are benefits and
                                    alternatives to receiving these medications.
                                </Paragraph>

                                <Paragraph>
                                    5. I am aware that the practice of medicine and surgery is not an exact science, and I acknowledge that no
                                    guarantees have been made to me concerning the results of the procedure or anesthetic.
                                </Paragraph>
                            </div>
                        </div>
                    </div>
                )}

                {/* Page 4 */}
                {currentPage === 3 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white text-base font-medium text-black">
                        <div className="px-1 mx-8  py-2">

                            <Paragraph>
                                6. I understand that my Practitioner may participate in a fellowship, residency or internship program which
                                involves other physicians (“Other Physicians”) conducting certain parts of my procedure. In some cases the
                                Other Physicians may perform parts of my procedure such as making the opening and closing incision, which
                                may be done while my Practitioner is not in the operating room. I also understand that my Practitioner may
                                permit the Other Physicians to perform more material portions of my procedure, provided that my Practitioner
                                feels that the Other Physician is capable of performing such portions and provided that my Practitioner is
                                present, directly supervising the Other Physicians, and available to immediately intervene if necessary. I
                                consent for the Other Physicians to provide such treatment to me.
                            </Paragraph>
                            <Paragraph>
                                7. For the purpose of advancing medical knowledge, I have consented to the admittance of medical students and
                                other observers during my procedure, in accordance with ordinary practices of this medical facility. I also
                                consent to the recording of the procedure which might include closed-circuit television, video recording or
                                photography, and the preparation of drawings and similar illustrative graphic materials. I also consent to the
                                use of such recordings and other information about my procedure for research and scientific purposes.
                            </Paragraph>
                            <Paragraph>
                                8. I acknowledge that I have accurately informed my Practitioner of my medical history, medications prescribed,
                                all known allergies, unusual reactions to medications, radiopaque and radioactive media and anesthetic
                                agents.
                            </Paragraph>
                            <Paragraph>
                                9. I agree to admission at a hospital if, in the opinion of my Practitioner, such admission should be deemed
                                advisable in my best interest.
                            </Paragraph>
                            <Paragraph>
                                10. Following surgery, I will have a responsible adult drive me home as per previous arrangements. I realize that
                                impairment of full mental alertness may persist for several hours following the administration of anesthesia
                                and I will avoid making decisions, or taking part in activities which depend upon full concentration or
                                judgment.
                            </Paragraph>
                            <Paragraph>
                                11. I will read and comply with all written discharge instructions and directions provided to me.
                            </Paragraph>
                            <Paragraph>
                                12. I authorize the Surgery Center to dispose of any specimen or tissue taken from my body or to retain the
                                specimen or tissue for whatever reason they deem appropriate.
                            </Paragraph>
                            <Paragraph>
                                I certify that I have read and fully understand the above material, that the explanations referred to were made, and that all blanks or statements requiring insertion or completion were filled and inapplicable paragraphs, if any, were crossed out and initialed by me before I signed.
                            </Paragraph>


                            <div className="mb-4 flex flex-col sm:flex-row flex-wrap gap-4 items-center">
                                <p className="font-roboto text-base text-black whitespace-nowrap">
                                    {SurgeryFormData.first_name + " " + SurgeryFormData.last_name}
                                </p>
                                {SurgeryFormData['patient_signature'] && (
                                    <>
                                        <p className="font-roboto text-base text-black whitespace-nowrap mx-1">
                                            {SurgeryFormData.patientSignedDate}
                                        </p>
                                        <p className="font-roboto text-base text-black whitespace-nowrap">
                                            {SurgeryFormData.patientSignedTime}
                                        </p>
                                    </>
                                )}
                            </div>

                            <SignatureField
                                fieldName="patient_signature"
                                label="Patient Signature"
                                formData={SurgeryFormData}
                                isEditing={isEditing}
                                isDisabled={isNext}
                                signatures={signatures}
                                canvasRefs={canvasRefs}
                                invalidFields={invalidFields}
                                updateSignatureData={updateSignatureData}
                                clearSignature={clearSignature}
                                toggleEditMode={toggleEditMode}
                                isNext={isNext}
                            />

                        </div>
                    </div>
                )}
                {/* Page 5 */}
                {currentPage === 4 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white text-base font-medium text-black">
                        <div className="px-1 mx-8 py-2">

                            {/* Fax Instructions */}
                            <Paragraph>If Patient is unable to sign for himself/herself</Paragraph>


                            <div className="flex items-center gap-4 w-full">
                                <div className="flex flex-col justify-between gap-10">
                                    <label className="block text-base font-medium text-black">Patient unable to sign because:</label>
                                    <label className="block text-base font-medium text-black">Printed Name</label>
                                    <label className="block text-base font-medium text-black">Witness</label>
                                </div>

                                <div className="w-full flex flex-col gap-4 max-w-[90%]">
                                    <FormInput
                                        id="reason"
                                        label=""
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData.unable_to_sign.reason}
                                        onChange={handleInputChange}
                                    />

                                    <div className="flex items-center gap-4">
                                        <FormInput
                                            id="printedName"
                                            label=""
                                            type="text"
                                            disabled={isNext}
                                            value={SurgeryFormData.unable_to_sign.printedName}
                                            onChange={handleNestedInputChange}
                                        />

                                        <FormInput
                                            id="relationship"
                                            label="Relationship to Patient"
                                            type="text"
                                            disabled={isNext}
                                            value={SurgeryFormData.unable_to_sign.relationship}
                                            onChange={handleNestedInputChange}
                                        />
                                    </div>

                                    <FormInput
                                        id="witness"
                                        label=""
                                        type="text"
                                        disabled={isNext}
                                        value={SurgeryFormData.unable_to_sign.witness}
                                        onChange={handleNestedInputChange}
                                    />
                                </div>
                            </div>


                            <div className="mb-2 mt-4 w-70% flex flex-col">
                                <div className="font-bold flex gap-4 mt-8 w-full text-black ">
                                    <p>Signature of Surrogate or Proxy</p>
                                    {SurgeryFormData['surrogate_signature'] && (
                                        <>
                                            <p className="font-roboto text-base text-black">
                                                {SurgeryFormData.surrogateSignedDate}
                                            </p>
                                            <p className="font-roboto text-base text-black">
                                                {SurgeryFormData.surrogateSignedTime}
                                            </p>
                                        </>
                                    )}

                                </div>


                                <SignatureField
                                    fieldName="surrogate_signature"
                                    label=""
                                    formData={SurgeryFormData}
                                    isEditing={isEditing}
                                    isDisabled={isNext}
                                    signatures={signatures}
                                    canvasRefs={canvasRefs}
                                    invalidFields={invalidFields}
                                    updateSignatureData={updateSignatureData}
                                    clearSignature={clearSignature}
                                    toggleEditMode={toggleEditMode}
                                    isNext={isNext}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {/* Page 6 */}
                {currentPage === 5 && (
                    <div ref={pageRefs.current[currentPage]} className=" max-w-5xl bg-white">
                        <div className="px-1 mx-8 py-2">

                            <Logo src={andrews} className="w-20 h-30" contactInfo={contactInfo} showContact={true} />
                            <Head title={pageTitles['Andrews Institute'][currentPage]} />
                            {/* <div className='my-4'>
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="font-medium">Patient Name: <span className="font-medium">{SurgeryFormData.first_name} {SurgeryFormData.last_name}</span></label>
                                                    </div>
                                                    <div>
                                                        <label className="font-medium">Date of Birth: <span className="font-medium">{verifyDob}</span></label>
                                                    </div>
                                                    <div>
                                                        <label className="font-medium">Date: <span className="font-medium">{SurgeryFormData.requested_date_of_surgery}</span></label>
                                                    </div>
                                                    <div>
                                                        <label className="font-medium">
                                                            Time: <span className="font-medium">
                                                                {SurgeryFormData.requested_time_of_surgery
                                                                    ? new Date(SurgeryFormData.requested_time_of_surgery).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                                                                    : ""}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div> */}
                            <SurgeryInfoDisplay SurgeryFormData={SurgeryFormData} />


                            <TextInput
                                id="allergies"
                                label="Allergies"
                                value={SurgeryFormData.allergies}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("allergies") && !SurgeryFormData.allergies}
                            />
                            <div className=" bg-white mx-auto">
                                <label htmlFor="andrew_admission" className="block font-bold col-span-1 mb-4">Admission</label>
                                {Object.keys(SurgeryFormData.andrew_admission).map((key) => (
                                    <div key={key} className="flex space-x-3 mb-2">
                                        <input
                                            type="checkbox"
                                            id={key}
                                            disabled={isNext}
                                            checked={SurgeryFormData.andrew_admission[key] === true}
                                            onChange={() => handleCheckboxChange("andrew_admission", key, !SurgeryFormData.andrew_admission[key])}
                                            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <label htmlFor={key} className="text-black font-medium">{key}</label>
                                    </div>
                                ))}
                            </div>

                            <div>
                                <h2 className="text-lg font-semibold mb-4">Medications</h2>
                                <div className="grid grid-cols-1 gap-4">
                                    {Object.keys(SurgeryFormData.andrew_medication_times).map((med) => (
                                        <div key={med} className="space-y-2">
                                            <p className="text-black font-medium">
                                                {med} one drop in operative eye every 5 minutes times 3 on call to OR Given at
                                            </p>
                                            <div className="grid grid-cols-3 gap-4">
                                                {SurgeryFormData.andrew_medication_times[med].map((time, index) => (
                                                    <div key={index} className="flex items-center space-x-2">

                                                        <MedTimePicker
                                                            value={time}
                                                            onChange={(val) => handleMedicationTimeChange("andrew_medication_times", med, index, val)}
                                                            disabled={isNext}
                                                        />

                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                            <div className="mt-4">

                                <h2 className="text-lg font-semibold">Additional Orders</h2>
                            </div>
                            <TextArea

                                id="additionalorders"
                                value={SurgeryFormData.additionalorders}
                                onChange={handleInputChange}
                                disabled={false}
                            />
                            <div className="grid grid-cols-12">
                                <div className="flex col-span-6">
                                    <div className="w-[75%] mb-2">
                                        <div className="font-semibold flex gap-2 text-black pb-4">

                                            <p>{SurgeryFormData.surgeon}</p>
                                            {SurgeryFormData['doctor_signature'] && (
                                                null
                                            )}
                                        </div>

                                        {SurgeryFormData['doctor_signature'] && !isEditing['doctor_signature'] ? ( // Toggle between edit and display mode

                                            <img
                                                src={SurgeryFormData['doctor_signature']}
                                                alt="Signature"
                                                loading="eager"
                                                style={{
                                                    width: '300px',
                                                    height: '100px',
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                                    border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                                    objectFit: 'contain',
                                                    display: 'block',
                                                }}
                                            />

                                        ) : (
                                            null
                                        )}

                                    </div>
                                </div>
                                <div className="flex col-span-6">
                                    <div className="w-[75%] mb-2">
                                        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 font-semibold text-black pb-4">
                                            <p className="whitespace-nowrap">RN Sign/Orders Noted</p>
                                            {SurgeryFormData['rn_signature'] && (
                                                <>
                                                    <p className="font-roboto text-base text-black whitespace-nowrap">
                                                        {SurgeryFormData.rnSignedDate}
                                                    </p>
                                                    <p className="font-roboto text-base text-black whitespace-nowrap">
                                                        {SurgeryFormData.rnSignedTime}
                                                    </p>
                                                </>
                                            )}
                                        </div>

                                        <SignatureField
                                            fieldName="rn_signature"
                                            label=""
                                            formData={SurgeryFormData}
                                            isEditing={isEditing}
                                            isDisabled={isNext}
                                            signatures={signatures}
                                            canvasRefs={canvasRefs}
                                            invalidFields={invalidFields}
                                            updateSignatureData={updateSignatureData}
                                            clearSignature={clearSignature}
                                            toggleEditMode={toggleEditMode}
                                            isNext={isNext}
                                        />
                                    </div>
                                </div>
                            </div>
                            <TextArea
                                id="procedure_description"
                                value={SurgeryFormData.procedure_description}
                                onChange={handleInputChange}
                                disabled={true}
                            />

                        </div>
                    </div>
                )}
                {/* page 7 */}
                {currentPage === 6 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-5xl bg-white text-base font-medium text-black">
                        <div className="px-1 mx-8  py-2">

                            <Logo src={andrews} className="w-20 h-30" contactInfo={contactInfo} showContact={true} />
                            <Head title={pageTitles['Andrews Institute'][currentPage]} />
                            {/* Fax Instructions */}

                            <Paragraph>(Please call you physician to schedule your medical clearance appointment)</ Paragraph>
                            <Paragraph>
                                Dear Dr.{" "}

                                <input
                                    type="text"
                                    id="pcp"
                                    name="pcp"
                                    disabled={isNext}
                                    value={SurgeryFormData.pcp}
                                    onChange={handleInputChange}
                                    className="inline-block border-0 border-b border-gray-400 focus:outline-none focus:border-b-2 focus:border-indigo-500 px-1 w-48" />
                            </ Paragraph>


                            <Paragraph>Your patient:  <span className="font-bold">{SurgeryFormData.first_name + " " + SurgeryFormData.last_name}</span> is scheduled to undergo a Vitrectomy surgery at the Andrews Institute A.S.C. in the near future. I would appreciate your help in evaluation of this patient to be certain that surgery can be performed safely. </ Paragraph>
                            <Paragraph>
                                In addition to the physical examination, the Anesthesia Department requires the following minimal studies within 30 days of surgery.
                            </ Paragraph>
                            <h3 className="mb-2 text-black text-base">PCP Risk Assessment</h3>
                            <Paragraph><span className="font-bold text-black">Electrocardiogram:</span> COPY REQUIRED (copy valid with 6 months of surgery) </ Paragraph>
                            <Paragraph><span className="font-bold text-black">Diuretic Therapy:</span>(If applies) Potassium level (within 30 days of surgery) </ Paragraph>
                            <Paragraph><span className="font-bold text-black">Anti-coagulant drug hole period:</span>(if applies) Advise on how many days to hold. Surgery center will order a PT/INR on date of service if Coumadin is not held greater than 5 days before procedure. </ Paragraph>
                            <Paragraph><span className="font-bold text-black">Chest X-ray:</span>Suspect pulmonary history (copy within one year of date of service unless recent discovery. Copy should be within one week of symptoms. </ Paragraph>
                            <Paragraph>
                                We would appreciate it if you would fax this information to both <span className="font-bold">Retina Specialty Institute @ 727-285-9316 and  Andrews Institute A.S.C. @ 850-916-8539.</span> </ Paragraph>
                            <Paragraph>Thank you very much for your help. If I can provide other information, please let me know.
                            </ Paragraph>

                            <div className="mb-4 mt-4 w-1/2 text-base">
                                <Paragraph>Best regards,
                                </ Paragraph>


                                {SurgeryFormData['doctor_signature'] && !isEditing['doctor_signature'] ? ( // Toggle between edit and display mode

                                    <img
                                        src={SurgeryFormData['doctor_signature']}
                                        alt="Signature"
                                        loading="eager"
                                        style={{
                                            width: '300px',
                                            height: '100px',
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                            objectFit: 'contain',
                                            display: 'block',
                                        }}
                                    />
                                ) : (
                                    null
                                )}

                                <div>
                                    <Paragraph>Sunil Gupta, M.D </ Paragraph>
                                    <Paragraph>John P. Myers, M.D.</ Paragraph>
                                    <Paragraph>Ryan Tarantola, M.D.</ Paragraph>
                                    <Paragraph>Ahmet Ozkok, M.D.</ Paragraph>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* Page 8 */}
                {currentPage === 7 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-5xl bg-white text-base font-medium text-black">
                        <div className="px-1 mx-8  py-2">

                            <Head title={pageTitles['Andrews Institute'][currentPage]} />

                            <div className="flex items-center gap-2 pl-8">
                                <Paragraph>
                                    It is imperative that you speak with the Andrews Institute preadmission testing department prior to your upcoming surgery. They will be attempting to reach you within three days of your scheduled surgery.
                                </Paragraph>

                            </div>
                            <div className="p-6 space-y-4">
                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>1. Do you have a history of difficult intubation?</Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="difficult_intubation" name="difficult_intubation" value="Yes" checked={SurgeryFormData.difficult_intubation === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="difficult_intubation" name="difficult_intubation" value="No" checked={SurgeryFormData.difficult_intubation === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>2. Do you or a family member have a history of Malignant Hyperthermia?</Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="malignant_hyperthermia" name="malignant_hyperthermia" value="Yes" checked={SurgeryFormData.malignant_hyperthermia === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="malignant_hyperthermia" name="malignant_hyperthermia" value="No" checked={SurgeryFormData.malignant_hyperthermia === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>3. Are you on any blood thinners?</Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="blood_thinners" name="blood_thinners" value="Yes" checked={SurgeryFormData.blood_thinners === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="blood_thinners" name="blood_thinners" value="No" checked={SurgeryFormData.blood_thinners === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                    {SurgeryFormData.blood_thinners === "Yes" && (
                                        <textarea id="blood_thinners_list" placeholder="List" value={SurgeryFormData.blood_thinners_list || ""} className="font-medium w-full p-2 border rounded" onChange={handleInputChange} />
                                    )}
                                </div>


                                <div className="p-4 border rounded-xl shadow-sm flex items-center gap-6 flex-nowrap">
                                    <p className="font-medium whitespace-nowrap">4. What is your height?</p>
                                    <input
                                        type="text"
                                        id="height"
                                        className="font-medium p-2 rounded border border-gray-300 w-[10%]"
                                        value={SurgeryFormData.height || ""}
                                        onChange={handleInputChange}
                                    />
                                    <p className="font-medium whitespace-nowrap">4. What is your weight?</p>
                                    <input
                                        type="text"
                                        id="weight"
                                        className="font-medium p-2 border border-gray-300 rounded w-[10%]"
                                        value={SurgeryFormData.weight || ""}
                                        onChange={handleInputChange}
                                    />
                                </div>


                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>5. Do you have a pacemaker?</Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="pacemaker" name="pacemaker" value="Yes" checked={SurgeryFormData.pacemaker === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="pacemaker" name="pacemaker" value="No" checked={SurgeryFormData.pacemaker === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                    {SurgeryFormData.pacemaker === "Yes" && (
                                        <div className="space-y-2">
                                            <Paragraph>Are you totally pacemaker dependent?</Paragraph>

                                            <div className="flex gap-4">
                                                <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="pacemaker_dependent" name="pacemaker_dependent" value="Yes" checked={SurgeryFormData.pacemaker_dependent === "Yes"} onChange={handleInputChange} /> Yes</label>
                                                <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="pacemaker_dependent" name="pacemaker_dependent" value="No" checked={SurgeryFormData.pacemaker_dependent === "No"} onChange={handleInputChange} /> No</label>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>6. Do you have an AICD (defibrillator)?</Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="defibrillator" name="defibrillator" value="Yes" checked={SurgeryFormData.defibrillator === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="defibrillator" name="defibrillator" value="No" checked={SurgeryFormData.defibrillator === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                    {SurgeryFormData.defibrillator === "Yes" && (
                                        <textarea id="defibrillator_fired" value={SurgeryFormData.defibrillator_fired || ""} placeholder="If Yes, has it ever fired?" className="font-medium w-full p-2 border rounded" onChange={handleInputChange} />
                                    )}
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>7. Have you had any recent chest pain?</Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="chest_pain" name="chest_pain" value="Yes" checked={SurgeryFormData.chest_pain === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="chest_pain" name="chest_pain" value="No" checked={SurgeryFormData.chest_pain === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                )}

                {/* Page 9 */}
                {currentPage === 8 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-5xl bg-white text-base font-medium text-black">
                        <div className="px-1 mx-8  py-2">


                            <div className="flex items-center gap-2 pl-8">

                                <Paragraph> It is imperative that you speak with the Andrews Institute preadmission testing department prior to your upcoming surgery. They will be attempting to reach you within three days of your scheduled surgery.
                                </Paragraph>

                            </div>
                            <div className="p-6 space-y-4">
                                <div className="p-4 border rounded-xl shadow-sm space-y-2">

                                    <Paragraph>8. Are you on oxygen at home?
                                    </Paragraph>

                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="oxygenTaker" name="oxygenTaker" value="Yes" checked={SurgeryFormData.oxygenTaker === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="oxygenTaker" name="oxygenTaker" value="No" checked={SurgeryFormData.oxygenTaker === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>9. Are you on hemodialysis for kidney dysfunction?
                                    </Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="hemodialysis_user" name="hemodialysis_user" value="Yes" checked={SurgeryFormData.hemodialysis_user === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="hemodialysis_user" name="hemodialysis_user" value="No" checked={SurgeryFormData.hemodialysis_user === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>10. Are you taking any weight loss drugs such as phentermine?
                                    </Paragraph>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="weight_loss_drugs_taker" name="weight_loss_drugs_taker" value="Yes" checked={SurgeryFormData.weight_loss_drugs_taker === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" id="weight_loss_drugs_taker" name="weight_loss_drugs_taker" value="No" checked={SurgeryFormData.weight_loss_drugs_taker === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                    {SurgeryFormData.weight_loss_drugs_taker === "Yes" && (<>
                                        <textarea id="weight_loss_drugs" placeholder="List" value={SurgeryFormData.weight_loss_drugs} className="font-medium w-full p-2 border rounded" onChange={handleInputChange} />
                                    </>
                                    )}
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>11. Are you taking a diuretic (water pill)? If YES to (11), you may require blood work before surgery.
                                    </Paragraph>

                                    <div className="flex gap-4">
                                        <label><input type="radio" id="diuretic_taker" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" name="diuretic_taker" value="Yes" checked={SurgeryFormData.diuretic_taker === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" id="diuretic_taker" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" name="diuretic_taker" value="No" checked={SurgeryFormData.diuretic_taker === "No"} onChange={handleInputChange} /> No</label>
                                    </div>
                                </div>

                                <div className="p-4 border rounded-xl shadow-sm space-y-2">
                                    <Paragraph>12. Are you claustrophobic? You will have a drape covering your face. If YES to (12), you need to have a conversation with the anesthesiologist regarding the possible need for GENERAL anesthesia.?
                                    </Paragraph>
                                    <p></p>
                                    <div className="flex gap-4">
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" name="claustrophobic" value="Yes" id="claustrophobic" checked={SurgeryFormData.claustrophobic === "Yes"} onChange={handleInputChange} /> Yes</label>
                                        <label><input type="radio" className="font-medium appearance-none w-4 h-4 border border-gray-400 rounded-sm checked:bg-blue-500 checked:border-transparent focus:outline-none cursor-pointer" name="claustrophobic" value="No" id="claustrophobic" checked={SurgeryFormData.claustrophobic === "No"} onChange={handleInputChange} /> No</label>
                                    </div>

                                </div>


                                <div className="font-bold py-2">
                                    {SurgeryFormData.first_name}&nbsp;
                                    {SurgeryFormData.last_name}&nbsp;&nbsp;&nbsp;&nbsp;
                                    {displayDate(SurgeryFormData.dob)}&nbsp;&nbsp;&nbsp;&nbsp;
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </form>
            <div className="max-w-5xl w-full">
                <div className="flex justify-end px-1 mx-8 py-2 mt-6">
                    {/* {renderEditButton()} */}
                    {[0, 1, 2, 3, 4, 5, 6, 7].includes(currentPage) ? renderNextButton() : renderSurgeryUploadButton()}
                </div>
            </div>
        </>
    );
};

export default Andrews;
